import styled from 'styled-components';

import {
  Content as ContentModal,
  CloseButton,
  Container as ContainerModal,
} from '~/components/Modal/styles';
import colors from '~/styles/colors';

export const ModalContainer = styled.div`
  ${ContainerModal} {
    z-index: 9999;
  }

  ${ContentModal} {
    padding: 24px;
    border-radius: 10px;
    width: auto;
  }

  ${CloseButton} {
    display: block;
    margin: -12px -12px 0 0;
  }
`;

export const ModalContentContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;

  h2 {
    margin: 16px 0 12px 0;
  }

  p {
    font-size: 17px;
    margin: 12px 0 24px 0;
  }

  div {
    display: grid;
    width: 100%;
    grid-template-columns: 1fr 1fr;
    gap: 8px;

    > * {
      width: 100%;
      height: 40px;
      border-radius: 5px;
      border-color: ${colors.primary};
      font-size: 17px;

      &:hover {
        opacity: 0.75;
      }
    }
  }
`;

export const ModalSubmitButton = styled.button`
  color: ${colors.white};
  background: ${colors.primary};
`;

export const ModalCancelButton = styled.button`
  color: ${colors.primary};
  background: transparent;
`;

export const ErrorButtonContainer = styled.div`
  display: block !important;
  width: 402px;
`;

export const SuccessMessage = styled.p`
  margin-bottom: 0px !important;
  width: 172px;
  text-align: center;
`;
